<template>
    <x-tag
        :small="small"
        :disabled="true"
        :class="[status, { inverse: inverse }]"
    >
        {{ status | riskStatus }}
    </x-tag>
</template>

<script>
export default {
    name: "StatusChip",
    props: {
        status: String,
        small: Boolean,
        inverse: Boolean,
    },
};
</script>

<style lang="scss" scoped>
.x-tag {
    height: 24px;
    background: $color-grey-5;
    font-family: $font-body;
    font-size: rem(12px);
    font-weight: 600;
    color: $color-grey-1;
    text-transform: uppercase;
    letter-spacing: rem(-0.3px);
    justify-content: center;
    min-width: auto;

    :deep(.x-tag__content) {
        padding: 0 15px;
    }

    &.x-tag--small {
        height: 20px !important; // !important is required here as Vuetify uses it for '.x-tag--small' modifier
        min-width: 102px;

        :deep(.x-tag__content) {
            padding: 0 6px;
        }
    }

    &.draft {
        background: $color-draft;
        color: $color-grey-10;
    }

    &.in_progress {
        background: $color-draft;
        color: $color-grey-10;
    }

    &.requested {
        background: $color-requested;
    }

    &.in_the_market {
        background: $color-in-the-market;
    }

    &.reviewing {
        background: $color-reviewing;
    }

    &.captive_reviewing {
        background: $color-reviewing;
    }

    &.firm_order {
        background: $color-firm-order;
    }

    &.firm_order_requested {
        background: $color-cobalt;
    }

    &.offered {
        background: $color-offered;
        color: $color-grey-10;
    }

    &.accepted {
        background: $color-accepted;
    }

    &.approved {
        background: $color-approved;
    }

    &.declined {
        background: $color-declined;
    }

    &.ntu {
        background: $color-ntu;
    }

    &.expired {
        background: $color-expired;
    }

    &.cancelled {
        background: $color-cancelled;
    }

    &.pending {
        background: $color-orange;
    }

    &.closed {
        background: $color-closed;
    }

    &.firm_ordered {
        background: $color-firm-ordered;
    }

    &.bound {
        background: $color-bound;
    }

    &.query {
        background: $color-query;
    }

    &.off_risk {
        background: $color-off-risk;
    }

    &.off_risk_amendment {
        background: $color-off-risk-amendment;
    }

    &.inverse {
        background: $color-white;
        // inverse text colors will change depending on status, these colors will be added once designs have supplied gradients for each status' submission header
        color: $gradient-purple-start;
    }
}
</style>
